<template>
  <div class="celebration-container">
    <div v-if="message.messageBody" class="celebration-container__text">
      <i class="fa fa-times" aria-hidden="true" @click="closeBanner()"></i>

      <span v-for="(line, lineNumber) of message.messageBody.split('\n')" v-bind:key="lineNumber">
        {{ line }}<br />
      </span>
    </div>
    <canvas id="celebration-container__canvas"></canvas>
  </div>
</template>

<script>
import ConfettiGenerator from "confetti-js";
import { mapState } from "vuex";
import { hexToRgb } from "@/helpers/helpers";

export default {
  name: "CelebrationsBanner",
  props: {
    message: Object
  },
  data() {
    return {
      timer: null
    };
  },
  computed: {
    ...mapState({
      colors: state => state.themeStyles,
      defaultConfettiConfig: state => state.event.config.defaultConfettiConfig
    }),
    hexColors() {
      let hexColors = [];
      for (let key in this.colors) {
        hexColors.push(this.colors[key].color);
      }
      return hexColors;
    },
    rgbColors() {
      return this.hexColors.map(color => hexToRgb(color));
    },
    confettiSettings() {
      return {
        target: "celebration-container__canvas",
        colors: this.rgbColors,
        ...this.defaultConfettiConfig
      };
    }
  },
  methods: {
    closeBanner() {
      this.$emit("close-banner");
    }
  },
  mounted() {
    let confetti = new ConfettiGenerator(this.confettiSettings);
    confetti.render();
  }
};
</script>

<style></style>
